module.exports = __webpack_public_path__ + "static/media/after.1f6fe29f.png";